import React, { Component } from 'react';
import {setAndGetAttributes} from '../../../Components/FormInputFields/FormInputFunctions';
// import Datetime from 'react-datetime';
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';
import {getDateFormat} from '../../../Utils/UserFunctions';
import {isSet,dateTimeValidation} from '../../../Utils/CommonFunctions';
import Wrp from "../../../hoc/Wrp/Wrp";
import MomentUtils from '@date-io/moment';
import {
  DateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
// cyan lightBlue
import blue from "@material-ui/core/colors/blue";
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';



class DateTimePick extends Component {

  constructor() {
      super();
      this.state = {
        dt: moment(),
        setDt: moment(),
        value:''
      };
    }

  fieldOnChangeHandler = (moment)=>{
    const {changeHandler,attributes} = this.props;
    if (isSet(moment,null)!==null &&   typeof moment.format === "function") {
        const  systemFormat =  moment.format((isSet(getDateFormat('DateTime'),null)!==null)?getDateFormat('DateTime'):'YYYY-MM-DDTHH:mm:ss'); //moment.format(getDateFormat('DateTime'))
        //changeHandler(systemFormat);
        this.props.filterOnChange(systemFormat ,this.props.attr1, this.props.fieldtype, this.props.filterObject.has_multiple_input,this.props.attr5,this.props.attr6)
    }else{
      //changeHandler(null);
      this.props.filterOnChange(null ,this.props.attr1, this.props.fieldtype, this.props.filterObject.has_multiple_input,this.props.attr5,this.props.attr6)
    }
  } 

  dateChange = (moment) => {
    const {changeHandler,attributes} = this.props;
    //let fieldDetail = JSON.parse(this.props.fieldDetails);
    if (typeof moment.format === "function") {
      changeHandler(moment.format(getDateFormat('DateTime')));
      this.setState({value:moment.format(getDateFormat('DateTime'))})
    }else{
      if(dateTimeValidation(moment) === true) {
        changeHandler(moment);
        this.setState({value:moment})

      }
    }      
  } 

  render() {
    const {value} = this.props;
    let attr = setAndGetAttributes(this.props);
    const dateFormat = (isSet(getDateFormat('DateTime'),null)!==null)?getDateFormat('DateTime'):'YYYY-MM-DDTHH:mm:ss';
    let dispValue = '';
    // if(dateFormat==='UNIX'){
    //   dispValue = (isSet(value,null)!==null)?moment(value).format(getDateFormat('DateTime')):'';
    // }else{
    //   dispValue = (isSet(value,null)!==null)?moment(value, dateFormat, true).format(getDateFormat('DateTime')):'';
    // }
    if(dateFormat==='UNIX'){
      dispValue = (isSet(value,null)!==null)?moment(value):'';//.format(getDateFormat())
    }else{
      dispValue = (isSet(value,null)!==null)?moment(value, dateFormat,true):'';//.format(getDateFormat())
    }
    const materialTheme = createTheme({
      palette: {
        primary: blue,
      },
    });
   
    return (
      <Wrp>
        <ThemeProvider theme={materialTheme}>
            <MuiPickersUtilsProvider utils={MomentUtils} >
              <DateTimePicker
                fullWidth
                keyboard
                clearable
                margin="normal"
                ampm={false}
                defaultValue={null} 
                //value={isSet(dispValue,null)}
                value={(isSet(value,null)!==null  && isSet(value,null)!=='Invalid date')?value:null}
                // value={(isSet(dispValue,null)!==null  && isSet(dispValue,null)!=='Invalid date')?moment(dispValue, getDateFormat('DateTime'), true):null}//this.state.selectedDate}//attr.value}
                // disablePast
                onChange={this.fieldOnChangeHandler}
                label=""
                // clearable={true}
                InputProps={{
                  ...attr,
                  // className:'form-control',
                  style: {fontSize: '0.8rem',borderTopLeftRadius:'0px',borderBottomLeftRadius:'0px',paddingLeft:'4px'},
                  disableUnderline: true,
                  autoComplete:'off',
                }}
                // readOnly={readonlyVal} 
                //  variant={'inline'}       
                // showTodayButton 
                format={getDateFormat('DateTime')}
                />
              </MuiPickersUtilsProvider>             
            </ThemeProvider>
      </Wrp>        
    );
  }
}

DateTimePick.defaultProps = {
  isMandatory:false,
  className: 'form-control'
}

export default DateTimePick;


/*
import React, { Component } from 'react';
// import Datetime from 'react-datetime';
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';
import {getDateFormatPicker, getDateFormat} from '../../../Utils/UserFunctions';
import Wrp from '../../../hoc/Wrp/Wrp';
import DateTimePick from '../../DateField/DateTimePick';
import { numericValidation} from '../../../Utils/CommonFunctions';

class DateTimePickComp extends Component {
  constructor() {
      super();
      this.state = {
        dt: moment(),
        setDt: moment()
      };
    }
    
  render() {
    let filterObject = this.props.filterObject;         
	  // let value = this.props.value; 
    
    // let value = this.props.value ? moment(this.props.value).format(getDateFormatPicker('DateTime')) : '';
    let classname = this.props.classname ? "form-control "+this.props.classname : "form-control";
    // console.log(this.props.value);
    return (

      <Wrp>
        {
        (filterObject.input_value_type==='Timestamp')
        ?
        <DateTimePick 
          timeFormat="HH:mm:ss" 
          values={ this.props.value }           
          dateChangeHandler={e=>this.props.filterOnChange(e ,this.props.attr1, this.props.fieldtype, filterObject.has_multiple_input,this.props.attr5,this.props.attr6)} 
          closeOnSelect={true}
          dateFormat={getDateFormat()}
        />

        : filterObject.input_value_type === "Integer" ?
        <Wrp>
        <input type="number" value={this.props.value} className={classname} onKeyPress={numericValidation} onChange={e=>this.props.filterOnChange(e, this.props.attr1, 'inputField', filterObject.has_multiple_input,this.props.attr4,this.props.attr6)} />
        </Wrp>
        : null
        }
      </Wrp>


    )
  }
}

DateTimePickComp.defaultProps = {
className:'form-control'
//id:"replaceColumnInput"+JSON.parse(this.props.fieldDetails.colIndex)
}

export default DateTimePickComp;
*/